import { render, staticRenderFns } from "./PaginationButtons.vue?vue&type=template&id=ab8c4d20"
import script from "./PaginationButtons.vue?vue&type=script&lang=js"
export * from "./PaginationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab8c4d20')) {
      api.createRecord('ab8c4d20', component.options)
    } else {
      api.reload('ab8c4d20', component.options)
    }
    module.hot.accept("./PaginationButtons.vue?vue&type=template&id=ab8c4d20", function () {
      api.rerender('ab8c4d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ServerSideDatatable/PaginationButtons.vue"
export default component.exports